import { defineMessages } from '@atlassian/jira-intl';

export const messages = defineMessages({
	projectNavigation: {
		id: 'horizontal-nav-common.common.tab-shortcut-context.project-navigation',
		defaultMessage: 'Project navigation',
		description:
			'Title for keyboard shortcuts in Keyboard Shortcuts dialog, above a list of shortcuts e.g. 1 - Go to Timeline, 2 - Go to Board, etc',
	},
	goTo: {
		id: 'horizontal-nav-common.common.tab-shortcut-context.go-to',
		defaultMessage: 'Go to {label}',
		description:
			'Name of the action shown in Command Palette and Keyboard Shortcuts dialog e.g. Go to Board, Go to Timeline, etc',
	},
});
